import { render, staticRenderFns } from "./certify.vue?vue&type=template&id=ea2d4b58&scoped=true"
import script from "./certify.vue?vue&type=script&lang=js"
export * from "./certify.vue?vue&type=script&lang=js"
import style0 from "./certify.vue?vue&type=style&index=0&id=ea2d4b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2d4b58",
  null
  
)

export default component.exports